import { useSelector, useDispatch } from 'react-redux';
import { TableRow, TableCell } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { setBalancesParams } from '@app/store/slices/balancesSlice';
import { Status } from '@shared/ui/parts';
import { useTopUpOrderDialog } from '@utils/dialogs-hooks';
import { theme } from '@utils/libs/theme';
import { balancesColumns } from '@utils/tables/columns';
import {
  BalanceAmountCell,
  BalanceAmountContent,
  BalanceBankCell,
  BalanceBankContent,
  BalanceDetailsCell,
  BalanceOperationCell,
  BalanceOperationDate,
  BalanceOperationType,
} from '@widgets/tables/cells/balance';
import { CustomTable, CustomTableMobile } from '@widgets/tables/main';

export default function BalancesTable() {
  const {
    balances,
    params,
    count_total,
    count_filtered,
    search,
    filtersCount,
    isLoading,
    isInitialized,
  } = useSelector((state) => state.balances);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { openTopUpOrderDialog } = useTopUpOrderDialog();
  const handleSetParams = (newParams) => {
    dispatch(setBalancesParams(newParams));
  };

  return isMobile ? (
    <CustomTableMobile
      params={params}
      setParams={handleSetParams}
      totalCount={count_total || 0}
      filteredCount={count_filtered || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      data={balances}
      filtersCount={filtersCount}
    >
      {balances?.map((row) => (
        <div
          key={row.order_id}
          onClick={
            row.type === 0 ? () => openTopUpOrderDialog(row.id_from) : undefined
          }
          className="tableMobile__list-item balancesMobile__item"
        >
          <div>
            <div className="balancesMobile__item-left">
              <BalanceBankContent row={row} isFrom />
              <BalanceBankContent row={row} />
            </div>
            <div className="status status--inactive">
              <BalanceOperationType row={row} />
            </div>
          </div>
          <div className="balancesMobile__item-right">
            <BalanceAmountContent row={row} />
            <BalanceOperationDate row={row} />
            <Status data={row.status} type="payments" />
          </div>
        </div>
      ))}
    </CustomTableMobile>
  ) : (
    <CustomTable
      columns={balancesColumns}
      data={balances}
      params={params}
      setParams={handleSetParams}
      filteredCount={count_filtered || 0}
      totalCount={count_total || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      filtersCount={filtersCount}
    >
      {balances?.map((row) => (
        <TableRow key={row.order_id}>
          <BalanceBankCell row={row} isFrom />
          <BalanceBankCell row={row} />
          <BalanceOperationCell row={row} />
          <TableCell>
            <Status data={row.status} type="payments" />
          </TableCell>
          <BalanceDetailsCell row={row} />
          <BalanceAmountCell row={row} />
        </TableRow>
      ))}
    </CustomTable>
  );
}
